// extracted by mini-css-extract-plugin
export default {"statuses-panel":"statuses_statuses-panel__Cwuvk","status-panel-content":"statuses_status-panel-content__Tr+UQ"};